.scroll-container {
    max-height: 330px;
    overflow-y: auto;
}
